/* AUTO GENERATED CONTENT: DO NOT MODIFY THIS FILE. SEE /TOOLS FOLDER FOR CHANGES */

import { css } from 'styled-components'

export const tokensCss = css`
  /* Typography */
  --font-family-primary: 'Inter', 'Inter fallback', sans-serif;
  --font-family-code: 'IBM Plex Mono', 'IBM Plex Mono fallback', sans-serif;
  --line-height-l: 120%;
  --line-height-m: 100%;
  --line-height-xl: 140%;
  --font-weight-semi-bold: 600;
  --font-weight-bold: 700;
  --font-weight-medium: 500;
  --font-weight-regular: 400;
  --font-size-xs: 10px;
  --font-size-s: 12px;
  --font-size-m: 14px;
  --font-size-l: 16px;
  --font-size-xl: 20px;
  --font-size-2xl: 24px;
  --font-size-3xl: 36px;
  --letter-spacing-m: 0%;
  --letter-spacing-l: 2%;
  --paragraph-spacing-0: 0px;
  --paragraph-spacing-1: 8px;

  --text-transform-none: none;
  --text-transform-uppercase: uppercase;
  --text-decoration-none: none;
  --text-decoration-line-through: line-through;
  --paragraph-indent-0: 0px;

  /* Dimensions */
  --border-radius-none: 0px;
  --border-radius-2xs: 4px;
  --border-radius-s: 8px;
  --border-radius-m: 10px;
  --border-radius-l: 12px;
  --border-radius-full: 999px;
  --border-radius-xs: 6px;
  --border-radius-xl: 20px;
  --border-radius-button-2xs: var(--border-radius-xs);
  --border-radius-button-xs: var(--border-radius-s);
  --border-radius-button-s: var(--border-radius-s);
  --border-radius-button-m: var(--border-radius-m);
  --border-radius-form-item-m: var(--border-radius-m);
  --border-radius-button-l: var(--border-radius-m);
  --border-radius-form-item-s: var(--border-radius-s);
  --border-radius-popover: var(--border-radius-l);
  --border-radius-section: var(--border-radius-l);
  --space-padding-form-item-m: var(--space-m);
  --space-padding-button-m: var(--space-s);
  --space-padding-button-s: var(--space-xs);
  --space-padding-button-nested: var(--space-m);
  --space-padding-form-item-nested: var(--space-m);
  --space-padding-form-item-s: var(--space-s);
  --space-margin-form-item-content: var(--space-xs);
  --space-padding-form-item-xs: var(--space-xs);
  --space-page: var(--space-xl);
  --space-modal: var(--space-xl);
  --space-wide-panel: var(--space-xl);
  --space-narrow-panel: var(--space-l);
  --space-section: var(--space-m);
  --space-page-content-m: var(--space-xl);
  --space-narrow-panel-content-m: var(--space-l);
  --space-wide-panel-content-m: var(--space-xl);
  --space-section-content-m: var(--space-m);
  --space-narrow-panel-content-s: var(--space-s);
  --space-wide-panel-content-s: var(--space-l);
  --space-section-content-s: var(--space-s);
  --space-page-content-s: var(--space-l);
  --space-narrow-panel-content-l: var(--space-xl);
  --space-xs: 12px;
  --space-2xs: 8px;
  --space-l: 24px;
  --space-s: 16px;
  --space-m: 20px;
  --space-3xs: 4px;
  --space-xl: 32px;
  --space-2xl: 40px;
  --space-3xl: 48px;
  --space-4xl: 56px;
  --space-5xl: 64px;
  --space-test: 64px;
  --height-control-height-m: 40px;
  --height-control-height-s: 32px;
  --height-control-height-l: 48px;
  --height-control-height-xl: 56px;
  --height-control-height-2xl: 64px;
  --height-control-height-xs: 24px;
  --height-control-height-2xs: 20px;
  --height-control-height-3xs: 16px;
  --height-form-item-m: var(--height-control-height-m);
  --height-form-item-s: var(--height-control-height-s);
  --height-form-item-nested: var(--height-control-height-l);
  --height-button-m: var(--height-control-height-m);
  --height-button-s: var(--height-control-height-s);

  /* Colors */
  --bg-node-item-delay: light-dark(var(--base-neutral-8), var(--base-neutral-8));
  --bg-node-item-delay-hovered: light-dark(var(--base-neutral-32), var(--base-neutral-32));
  --bg-node-item-evaluation: light-dark(var(--base-yellow-8), var(--base-yellow-8));
  --bg-node-item-evaluation-hovered: light-dark(var(--base-yellow-32), var(--base-yellow-32));
  --bg-node-item-action: light-dark(var(--base-green-8), var(--base-green-8));
  --bg-node-item-action-hovered: light-dark(var(--base-green-32), var(--base-green-32));
  --bg-node-item-interaction: light-dark(var(--base-blue-8), var(--base-blue-8));
  --bg-node-item-interaction-hovered: light-dark(var(--base-blue-32), var(--base-blue-32));
  --bg-node-item-trigger: light-dark(var(--base-purple-8), var(--base-purple-8));
  --bg-node-item-trigger-hovered: light-dark(var(--base-purple-32), var(--base-purple-32));
  --bg-node-item-enrich: light-dark(var(--base-pink-8), var(--base-pink-8));
  --bg-node-item-enrich-hovered: light-dark(var(--base-pink-32), var(--base-pink-32));
  --bg-node-item-chat-ai: light-dark(var(--base-neutral-100), var(--base-neutral-0));
  --bg-accent: light-dark(var(--base-neutral-100), var(--base-neutral-80));
  --bg-action-bar-button-caution-hovered: light-dark(var(--bg-caution), var(--bg-caution));
  --bg-action-bar-button-major-hovered: light-dark(var(--bg-action), var(--bg-action));
  --bg-action-bar-button-minor-hovered: light-dark(var(--bg-major), var(--bg-major));
  --bg-action-bar-button-major-default: light-dark(var(--bg-invisible), var(--bg-invisible));
  --bg-action-bar-button-minor-default: light-dark(var(--bg-invisible), var(--bg-invisible));
  --bg-action-bar-button-caution-default: light-dark(var(--bg-invisible), var(--bg-invisible));
  --bg-action-bar-button-major-active: light-dark(var(--bg-action), var(--bg-action));
  --bg-action-bar-button-minor-active: light-dark(var(--bg-major), var(--bg-major));
  --bg-action-bar-button-caution-active: light-dark(var(--bg-caution), var(--bg-caution));
  --bg-button-caution-default: light-dark(var(--bg-caution-emphasis), var(--bg-caution-emphasis));
  --bg-button-caution-active: light-dark(var(--bg-caution), var(--bg-caution));
  --bg-button-major-active: light-dark(var(--bg-action), var(--bg-action));
  --bg-button-minor-active: light-dark(var(--bg-major), var(--bg-major));
  --bg-button-moderate-active: light-dark(var(--bg-major), var(--bg-major));
  --bg-button-caution-hovered: light-dark(var(--base-red-64), var(--base-red-64));
  --bg-button-major-hovered: light-dark(var(--base-purple-64), var(--base-purple-64));
  --bg-button-minor-hovered: light-dark(var(--base-neutral-16), var(--base-neutral-16));
  --bg-button-moderate-hovered: light-dark(var(--base-neutral-16), var(--base-neutral-16));
  --bg-button-major-default: light-dark(var(--bg-action-emphasis), var(--bg-action-emphasis));
  --bg-button-minor-default: light-dark(var(--bg-minor), var(--bg-minor));
  --bg-button-moderate-default: light-dark(var(--bg-major), var(--bg-major));
  --bg-section: light-dark(var(--bg-minor), var(--bg-minor));
  --bg-section-emphasis: light-dark(var(--bg-major), var(--bg-major));
  --bg-dim-overlay: light-dark(
    var(--base-transparency-neutral-at-80),
    var(--base-transparency-neutral-at-80)
  );
  --bg-dropdown: light-dark(var(--bg-moderate), var(--bg-moderate));
  --bg-caution: light-dark(var(--base-red-8), var(--base-red-8));
  --bg-inform: light-dark(var(--base-blue-8), var(--base-blue-8));
  --bg-success: light-dark(var(--base-green-8), var(--base-green-8));
  --bg-warning: light-dark(var(--base-yellow-8), var(--base-yellow-8));
  --bg-form-item-error: light-dark(var(--bg-caution), var(--bg-caution));
  --bg-form-item-focused: light-dark(var(--bg-action), var(--bg-action));
  --bg-form-item-hovered: light-dark(var(--bg-major), var(--bg-major));
  --bg-form-item-default: light-dark(var(--bg-minor), var(--bg-minor));
  --bg-form-item-selection: light-dark(
    var(--base-transparency-purple-at-10),
    var(--base-transparency-purple-at-10)
  );
  --bg-list-item-hovered: light-dark(var(--bg-major), var(--bg-major));
  --bg-list-item-default: light-dark(var(--bg-dropdown), var(--bg-dropdown));
  --bg-list-item-selected: light-dark(var(--bg-minor), var(--bg-minor));
  --bg-modal: light-dark(var(--bg-moderate), var(--bg-moderate));
  --bg-moderate: light-dark(var(--base-neutral-2), var(--base-neutral-2));
  --bg-page: light-dark(var(--bg-moderate), var(--bg-moderate));
  --bg-row-default: light-dark(var(--bg-invisible), var(--bg-invisible));
  --bg-row-selected: light-dark(var(--bg-action), var(--bg-action));
  --bg-scrollbar-scrollbar-background: light-dark(var(--base-neutral-0), var(--base-neutral-0));
  --bg-scrollbar-scrollbar-control: light-dark(var(--base-neutral-12), var(--base-neutral-12));
  --bg-select-item-major-checked-disabled: light-dark(var(--base-purple-48), var(--base-purple-48));
  --bg-select-item-major-checked: light-dark(var(--bg-action-emphasis), var(--bg-action-emphasis));
  --bg-select-item-status-checked: light-dark(
    var(--bg-success-emphasis),
    var(--bg-success-emphasis)
  );
  --bg-select-item-status-checked-disabled: light-dark(var(--base-green-48), var(--base-green-48));
  --bg-select-item-unchecked: light-dark(var(--base-neutral-16), var(--base-neutral-16));
  --bg-select-item-unchecked-disabled: light-dark(var(--base-neutral-16), var(--base-neutral-16));
  --bg-skeleton-default: light-dark(var(--bg-major), var(--bg-major));
  --bg-skeleton-flicker: light-dark(var(--base-neutral-16), var(--base-neutral-16));
  --bg-disabled: light-dark(var(--base-neutral-8), var(--base-neutral-8));
  --bg-main-nav-hovered: light-dark(
    var(--base-transparency-purple-at-10),
    var(--base-transparency-purple-at-10)
  );
  --bg-main-nav-selected: light-dark(
    var(--base-transparency-purple-at-20),
    var(--base-transparency-purple-at-20)
  );
  --bg-main-nav-default: light-dark(var(--bg-invisible), var(--bg-invisible));
  --bg-main-nav-disabled: light-dark(
    var(--base-transparency-neutral-at-16),
    var(--base-transparency-neutral-at-16)
  );
  --bg-minor: light-dark(var(--base-neutral-0), var(--base-neutral-0));
  --bg-action-emphasis: light-dark(var(--base-purple-100), var(--base-purple-100));
  --bg-action: light-dark(var(--base-purple-8), var(--base-purple-8));
  --bg-success-emphasis: light-dark(var(--base-green-100), var(--base-green-100));
  --bg-major: light-dark(var(--base-neutral-8), var(--base-neutral-8));
  --bg-invisible: light-dark(#ffffff03, #151d2303);
  --bg-caution-emphasis: light-dark(var(--base-red-100), var(--base-red-100));
  --bg-action-bar: light-dark(var(--bg-page), var(--bg-page));
  --bg-navigation: light-dark(var(--base-neutral-100), var(--base-neutral-0));
  --bg-warning-emphasis: light-dark(var(--base-yellow-100), var(--base-yellow-100));
  --bg-inform-emphasis: light-dark(var(--base-blue-100), var(--base-blue-100));
  --bg-brand-emphasis: light-dark(var(--base-orange-80), var(--base-orange-80));
  --bg-calendar-item-grey: light-dark(var(--base-neutral-16), var(--base-neutral-16));
  --bg-calendar-item-grey-hovered: light-dark(var(--base-neutral-48), var(--base-neutral-48));
  --bg-calendar-item-red: light-dark(var(--base-red-16), var(--base-red-16));
  --bg-calendar-item-red-hovered: light-dark(var(--base-red-48), var(--base-red-48));
  --bg-calendar-item-orange: light-dark(var(--base-orange-16), var(--base-orange-16));
  --bg-calendar-item-orange-hovered: light-dark(var(--base-orange-48), var(--base-orange-48));
  --bg-calendar-item-yellow: light-dark(var(--base-yellow-16), var(--base-yellow-16));
  --bg-calendar-item-yellow-hovered: light-dark(var(--base-yellow-48), var(--base-yellow-48));
  --bg-calendar-item-green: light-dark(var(--base-green-16), var(--base-green-16));
  --bg-calendar-item-green-hovered: light-dark(var(--base-green-48), var(--base-green-48));
  --bg-calendar-item-blue: light-dark(var(--base-blue-16), var(--base-blue-16));
  --bg-calendar-item-blue-hovered: light-dark(var(--base-blue-48), var(--base-blue-48));
  --bg-calendar-item-purple: light-dark(var(--base-purple-16), var(--base-purple-16));
  --bg-calendar-item-purple-hovered: light-dark(var(--base-purple-48), var(--base-purple-48));
  --bg-calendar-item-pink: light-dark(#ff00ff14, #ff00ff14);
  --bg-calendar-item-pink-hovered: light-dark(#ff00ff7a, #ff00ff7a);
  --bg-calendar-item-grey-focused: light-dark(var(--base-neutral-80), var(--base-neutral-80));
  --bg-calendar-item-blue-focused: light-dark(var(--base-blue-100), var(--base-blue-100));
  --bg-calendar-item-purple-focused: light-dark(var(--base-purple-100), var(--base-purple-100));
  --bg-calendar-item-pink-focused: light-dark(#ff00ffcc, #ff00ffcc);
  --bg-calendar-item-red-focused: light-dark(var(--base-red-100), var(--base-red-100));
  --bg-calendar-item-orange-focused: light-dark(var(--base-orange-100), var(--base-orange-100));
  --bg-calendar-item-yellow-focused: light-dark(var(--base-yellow-100), var(--base-yellow-100));
  --bg-calendar-item-green-focused: light-dark(var(--base-green-100), var(--base-green-100));
  --bg-flow-builder-selection-area: light-dark(
    var(--base-transparency-purple-at-10),
    var(--base-transparency-purple-at-10)
  );
  --bg-chart-purple: light-dark(var(--base-purple-56), var(--base-purple-56));
  --bg-chart-yellow: light-dark(var(--base-yellow-56), var(--base-yellow-56));
  --bg-chart-red: light-dark(var(--base-red-56), var(--base-red-56));
  --bg-chart-blue: light-dark(var(--base-blue-56), var(--base-blue-56));
  --bg-chart-green: light-dark(var(--base-green-56), var(--base-green-56));
  --bg-chart-grey: light-dark(var(--base-neutral-32), var(--base-neutral-32));
  --bg-chart-orange: light-dark(var(--base-orange-56), var(--base-orange-56));
  --bg-brand: light-dark(var(--base-orange-16), var(--base-orange-16));
  --fg-hubspot: light-dark(#ff7857, #ff7857);
  --fg-salesforce: light-dark(#00a1e0, #00a1e0);
  --fg-caution: light-dark(var(--base-red-100), var(--base-red-100));
  --fg-success: light-dark(var(--base-green-100), var(--base-green-100));
  --fg-major-on-color: light-dark(var(--base-neutral-0), var(--base-neutral-0));
  --fg-brand: light-dark(var(--base-orange-80), var(--base-orange-80));
  --fg-inform: light-dark(var(--base-blue-100), var(--base-blue-100));
  --fg-action: light-dark(var(--base-purple-100), var(--base-purple-100));
  --fg-moderate: light-dark(var(--base-neutral-64), var(--base-neutral-64));
  --fg-moderate-on-color: light-dark(var(--base-neutral-32), var(--base-neutral-16));
  --fg-warning: light-dark(var(--base-yellow-100), var(--base-yellow-100));
  --fg-calendar-item-green: light-dark(var(--base-green-100), var(--base-green-100));
  --fg-calendar-item-blue: light-dark(var(--base-blue-100), var(--base-blue-100));
  --fg-calendar-item-yellow: light-dark(var(--base-yellow-100), var(--base-yellow-100));
  --fg-calendar-item-pink: light-dark(#c200c2, #d41cd4);
  --fg-calendar-item-grey: light-dark(var(--base-neutral-100), var(--base-neutral-100));
  --fg-calendar-item-red: light-dark(var(--base-red-100), var(--base-red-100));
  --fg-calendar-item-purple: light-dark(var(--base-purple-100), var(--base-purple-100));
  --fg-calendar-item-orange: light-dark(var(--base-orange-100), var(--base-orange-100));
  --fg-calendar-item-arrow: light-dark(var(--base-neutral-16), var(--base-neutral-16));
  --fg-disabled: light-dark(var(--base-neutral-64), var(--base-neutral-64));
  --fg-major: light-dark(var(--base-neutral-100), var(--base-neutral-100));
  --fg-minor: light-dark(var(--base-neutral-48), var(--base-neutral-48));
  --fg-action-on-color: light-dark(var(--base-purple-64), var(--fg-action));
  --fg-caution-on-color: light-dark(var(--base-red-64), var(--fg-caution));
  --fg-warning-on-color: light-dark(var(--base-yellow-64), var(--fg-warning));
  --fg-success-on-color: light-dark(var(--base-green-64), var(--fg-success));
  --fg-inform-on-color: light-dark(var(--base-blue-64), var(--fg-inform));
  --fg-node-item-action: light-dark(var(--base-green-100), var(--base-green-100));
  --fg-node-item-interaction: light-dark(var(--base-blue-100), var(--base-blue-100));
  --fg-node-item-evaluation: light-dark(var(--base-yellow-100), var(--base-yellow-100));
  --fg-node-item-delay: light-dark(var(--base-neutral-100), var(--base-neutral-100));
  --fg-node-item-trigger: light-dark(var(--base-purple-100), var(--base-purple-100));
  --fg-node-item-arrow: light-dark(var(--base-neutral-16), var(--base-neutral-16));
  --fg-node-item-enrich: light-dark(var(--base-pink-100), var(--base-pink-100));
  --fg-node-item-chat-ai: light-dark(var(--base-neutral-0), var(--base-neutral-100));
  --base-orange-8: light-dark(#ffeee6, #4c2a00);
  --base-orange-16: light-dark(#ffddcc, #813600);
  --base-orange-24: light-dark(#ffccb3, #933b00);
  --base-orange-32: light-dark(#ffbb99, #a53f00);
  --base-orange-40: light-dark(#ffaa80, #b74300);
  --base-orange-48: light-dark(#ff9966, #c94800);
  --base-orange-56: light-dark(#ff884d, #db4c00);
  --base-orange-64: light-dark(#ff7733, #ed5000);
  --base-orange-80: light-dark(#ff5500, #ff6b21);
  --base-orange-100: light-dark(#cc4400, #cc4400);
  --base-blue-8: light-dark(#ebf4fc, #00335d);
  --base-blue-16: light-dark(#cce6fa, #08487d);
  --base-blue-24: light-dark(#b3d9f8, #0c538d);
  --base-blue-32: light-dark(#99ccf6, #105e9d);
  --base-blue-40: light-dark(#80c0f4, #1469ae);
  --base-blue-48: light-dark(#66b3f1, #1873be);
  --base-blue-56: light-dark(#4da6ef, #1c7ece);
  --base-blue-64: light-dark(#3399ed, #2089de);
  --base-blue-80: light-dark(#0080e8, #2089de);
  --base-blue-100: light-dark(#006fc9, #299fff);
  --base-red-8: light-dark(#fcf0f0, #590201);
  --base-red-16: light-dark(#fce6e6, #690d0c);
  --base-red-24: light-dark(#f9cdcd, #7a1918);
  --base-red-32: light-dark(#f5b4b3, #8a2524);
  --base-red-40: light-dark(#f29b9a, #9b3130);
  --base-red-48: light-dark(#ef8381, #ac3d3c);
  --base-red-56: light-dark(#ec6a68, #bc4947);
  --base-red-64: light-dark(#e9514f, #cd5553);
  --base-red-80: light-dark(#e53835, #dd615f);
  --base-red-100: light-dark(#df0603, #ff7977);
  --base-green-8: light-dark(#e6f8f4, #004e3b);
  --base-green-16: light-dark(#ccf2e8, #005d46);
  --base-green-24: light-dark(#b3ebdd, #006c51);
  --base-green-32: light-dark(#99e5d2, #007b5c);
  --base-green-40: light-dark(#80dec7, #008a68);
  --base-green-48: light-dark(#66d7bb, #009973);
  --base-green-56: light-dark(#4dd1b0, #00a87e);
  --base-green-64: light-dark(#33caa5, #00b789);
  --base-green-80: light-dark(#00bd8e, #00c694);
  --base-green-100: light-dark(#008563, #00d5a0);
  --base-yellow-8: light-dark(#fff8e6, #4c3701);
  --base-yellow-16: light-dark(#fff1cd, #5d4503);
  --base-yellow-24: light-dark(#ffe9b3, #6f5305);
  --base-yellow-32: light-dark(#ffe29a, #816108);
  --base-yellow-40: light-dark(#ffdb81, #93700b);
  --base-yellow-48: light-dark(#ffd468, #a57e0d);
  --base-yellow-56: light-dark(#ffcd4f, #b78c10);
  --base-yellow-64: light-dark(#ffc535, #c99b12);
  --base-yellow-80: light-dark(#ffb703, #dba915);
  --base-yellow-100: light-dark(#a15f02, #ffc61a);
  --base-purple-8: light-dark(#f1efff, #221866);
  --base-purple-16: light-dark(#e4e0ff, #2f2475);
  --base-purple-24: light-dark(#d6d0ff, #3c3184);
  --base-purple-32: light-dark(#c8c1ff, #493e93);
  --base-purple-40: light-dark(#bbb1ff, #564ba3);
  --base-purple-48: light-dark(#ada2ff, #6358b2);
  --base-purple-56: light-dark(#9f92ff, #7065c1);
  --base-purple-64: light-dark(#9283ff, #7d72d1);
  --base-purple-80: light-dark(#7664ff, #8a7fe0);
  --base-purple-100: light-dark(#543dff, #a599ff);
  --base-neutral-0: light-dark(#ffffff, #151d23);
  --base-neutral-2: light-dark(#fafafb, #1c252b);
  --base-neutral-3: light-dark(#151d2308, #cfdae208);
  --base-neutral-4: light-dark(#f6f6f6, #242c32);
  --base-neutral-8: light-dark(#eceded, #333b42);
  --base-neutral-12: light-dark(#151d231f, #cfdae21f);
  --base-neutral-16: light-dark(#dadbdc, #515960);
  --base-neutral-20: light-dark(#151d2333, #cfdae233);
  --base-neutral-24: light-dark(#151d233d, #cfdae23d);
  --base-neutral-32: light-dark(#b4b7b9, #6e787f);
  --base-neutral-40: light-dark(#151d2366, #cfdae266);
  --base-neutral-48: light-dark(#8f9395, #8c969d);
  --base-neutral-56: light-dark(#151d238f, #cfdae28f);
  --base-neutral-64: light-dark(#676c6f, #b4b9bc);
  --base-neutral-80: light-dark(#444a4f, #dde0e2);
  --base-neutral-100: light-dark(#151d23, #ffffff);
  --base-transparency-neutral-at-80: light-dark(#151d23cc, #ffffff14);
  --base-transparency-neutral-at-32: light-dark(#151d2352, #ffffff52);
  --base-transparency-purple-at-20: light-dark(#a599ff33, #a599ff33);
  --base-transparency-purple-at-10: light-dark(#a599ff1a, #a599ff1a);
  --base-transparency-neutral-at-16: light-dark(#151d2329, #ffffff29);
  --base-transparency-orange-at-64: light-dark(#cc4400a3, #cc4400a3);
  --base-pink-8: light-dark(#faebfa, #262133);
  --base-pink-16: light-dark(#f5d6f5, #382643);
  --base-pink-24: light-dark(#f0c2f0, #492a54);
  --base-pink-32: light-dark(#ebadeb, #5a2f64);
  --base-pink-40: light-dark(#e799e7, #6c3374);
  --base-pink-48: light-dark(#e285e2, #7d3784);
  --base-pink-56: light-dark(#dd70dd, #8f3c95);
  --base-pink-64: light-dark(#d85cd8, #a040a5);
  --base-pink-80: light-dark(#ce33ce, #c349c5);
  --base-pink-100: light-dark(#c200c2, #ee54ee);
  --effect-minor: light-dark(var(--base-neutral-8), var(--base-neutral-8));
  --effect-drop-shadow: light-dark(
    var(--base-transparency-neutral-at-32),
    var(--base-transparency-neutral-at-32)
  );
  --effect-moderate: light-dark(var(--base-neutral-16), var(--base-neutral-16));
  --effect-action-emphasis: light-dark(var(--base-purple-100), var(--base-purple-100));
  --effect-action: light-dark(var(--base-purple-16), var(--base-purple-16));
  --effect-default-on-color: light-dark(var(--base-neutral-48), var(--base-neutral-48));
  --effect-moderate-on-color: light-dark(var(--base-neutral-80), var(--base-neutral-80));
  --effect-inform: light-dark(var(--base-blue-16), var(--base-blue-16));
  --effect-warning: light-dark(var(--base-yellow-16), var(--base-yellow-16));
  --effect-caution: light-dark(var(--base-red-16), var(--base-red-16));
  --effect-caution-emphasis: light-dark(var(--base-red-100), var(--base-red-100));
  --effect-inform-emphasis: light-dark(var(--base-blue-100), var(--base-blue-100));
  --effect-warning-emphasis: light-dark(var(--base-yellow-100), var(--base-yellow-100));
  --effect-success: light-dark(var(--base-green-16), var(--base-green-16));
  --effect-success-emphasis: light-dark(var(--base-green-100), var(--base-green-100));
  --effect-major: light-dark(var(--base-neutral-100), var(--base-neutral-100));
  --effect-brand-emphasis: light-dark(var(--base-orange-80), var(--base-orange-80));
  --effect-focus-indicator: light-dark(
    var(--base-transparency-neutral-at-32),
    var(--base-transparency-neutral-at-32)
  );
  --effect-minor-disabled: light-dark(var(--base-neutral-16), var(--base-neutral-16));
  --border-action-focused-caution: inset 0px -2px 0px 0px var(--effect-caution-emphasis);
  --border-action-focused-major: inset 0px -2px 0px 0px var(--effect-action-emphasis);
  --border-action-focused-minor: inset 0px -2px 0px 0px var(--effect-major);
  --border-action-focused-moderate: inset 0px -2px 0px 0px var(--effect-major);
  --border-calendar-cell:
    inset 0px -1px 0px 0px var(--effect-minor), inset -1px 0px 0px 0px var(--effect-minor);
  --border-card-item-hovered: inset 0px 0px 0px 1px var(--effect-action);
  --border-card-item-selected:
    inset 0px 0px 0px 1px var(--effect-action-emphasis), 0px 0px 0px 4px var(--effect-action);
  --border-cell: inset -1px 0px 0px 0px var(--effect-minor);
  --border-cell-disabled: inset -1px 0px 0px 0px var(--effect-minor-disabled);
  --border-cell-left: inset 1px 0px 0px 0px var(--effect-minor);
  --border-cell-left-on-color: inset 1px 0px 0px 0px var(--effect-moderate-on-color);
  --border-cell-on-color: inset -1px 0px 0px 0px var(--effect-moderate-on-color);
  --border-cell-sticky-left:
    4px 0px 0px 0px var(--effect-minor), inset -1px 0px 0px 0px var(--effect-moderate);
  --border-focus-indicator: inset 0px 0px 0px 2px var(--effect-focus-indicator);
  --border-focus-indicator-item-selected:
    inset 2px 0px 0px 0px var(--effect-action-emphasis),
    inset 0px 0px 0px 2px var(--effect-focus-indicator);
  --border-form-item-focused:
    inset 0px 0px 0px 1px var(--effect-minor), inset 0px -3px 0px 0px var(--effect-action-emphasis);
  --border-form-item-nested-focused: inset 0px -2px 0px 0px var(--effect-action-emphasis);
  --border-horizontal-nav-item-hovered: inset 0px -2px 0px 0px var(--effect-moderate);
  --border-horizontal-nav-item-major-selected: inset 0px -3px 0px 0px var(--effect-brand-emphasis);
  --border-horizontal-nav-item-minor-selected: inset 0px -3px 0px 0px var(--effect-major);
  --border-link-underline-caution: inset 0px -2px 0px 0px var(--effect-caution);
  --border-link-underline-caution-hover: inset 0px -2px 0px 0px var(--effect-caution-emphasis);
  --border-link-underline-major: inset 0px -2px 0px 0px var(--effect-action);
  --border-link-underline-major-hover: inset 0px -2px 0px 0px var(--effect-action-emphasis);
  --border-link-underline-minor: inset 0px -2px 0px 0px var(--effect-moderate);
  --border-link-underline-minor-hover: inset 0px -2px 0px 0px var(--effect-major);
  --border-link-underline-moderate-on-color: inset 0px -2px 0px 0px var(--effect-moderate-on-color);
  --border-list-item-selected:
    inset 3px 0px 0px 0px var(--effect-action-emphasis),
    inset 0px -1px 0px 0px var(--effect-moderate);
  --border-node:
    0px 12px 16px -10px var(--effect-drop-shadow), inset 0px 0px 0px 1px var(--effect-minor);
  --border-node-selected:
    inset 0px 0px 0px 1px var(--effect-action-emphasis), 0px 0px 0px 4px var(--effect-action);
  --border-page-divider-section: inset 0px -4px 0px 0px var(--effect-minor);
  --border-popover:
    inset 0px 0px 0px 1px var(--effect-minor), 0px 8px 20px -2px var(--effect-drop-shadow);
  --border-row: inset 0px -1px 0px 0px var(--effect-minor);
  --border-row-oncolor: inset 0px -1px 0px 0px var(--effect-moderate-on-color);
  --border-row-selected: inset 0px -1px 0px 0px var(--effect-moderate);
  --border-row-top: inset 0px 1px 0px 0px var(--effect-minor);
  --border-section: inset 0px 0px 0px 1px var(--effect-minor);
  --border-section-on-color: inset 0px 0px 0px 1px var(--effect-moderate-on-color);
  --border-inform: inset 0px 0px 0px 1px var(--effect-inform-emphasis);
  --border-success: inset 0px 0px 0px 1px var(--effect-success-emphasis);
  --border-link-underline-minor-on-color: inset 0px -2px 0px 0px var(--effect-moderate-on-color);
  --border-node-hovered: 0px 0px 0px 2px var(--effect-minor);
  --border-caution: inset 0px 0px 0px 1px var(--effect-caution-emphasis);
  --border-warning: inset 0px 0px 0px 1px var(--effect-warning-emphasis);
`
